import { render, staticRenderFns } from "./ConfiguratorIcon.vue?vue&type=template&id=2190d4d8&"
import script from "./ConfiguratorIcon.vue?vue&type=script&lang=js&"
export * from "./ConfiguratorIcon.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguratorIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports